import { usePlaces } from '@/hooks/usePlaces';
import { PlaceCard } from '@/components/PlaceCard';
import { useFavorites } from '@/hooks/useFavorites';

export function ExplorePage() {
  const { places, loading } = usePlaces('explore');
  const { isFavorite, toggle } = useFavorites();

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Explore</h1>
        <p className="page-subtitle">Beaches and day trips worth the drive</p>
      </div>
      {loading && <div className="skeleton" style={{ height: 140 }} />}
      {!loading && (places ?? []).length === 0 && <p className="empty-state">No explore destinations yet.</p>}
      {(places ?? []).map((p) => (
        <PlaceCard key={p.id} place={p} detailed isFavorite={isFavorite(p.id)} onToggleFavorite={toggle} />
      ))}
    </div>
  );
}
